import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { config, loadRuntimeConfig } from './app/runtime-config';

async function main(): Promise<void> {
  await loadRuntimeConfig();
  const { sentry } = config();

  if (sentry.dsn) {
    Sentry.init({
      dsn: sentry.dsn,
      environment: sentry.environment,
      enableLogs: sentry.enableLogs,
      sendDefaultPii: sentry.sendDefaultPii,
      integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
      tracesSampleRate: sentry.tracesSampleRate,
      profileSessionSampleRate: sentry.profileSessionSampleRate,
      // Profile only while a sampled trace is running, so every profile belongs to a page load or navigation.
      profileLifecycle: 'trace',
    });
  }

  LicenseManager.setLicenseKey(environment.agGridLicenseKey);

  // Imported dynamically, and only now: a static import would be evaluated before this
  // function ever runs, and the app graph reads the runtime config at module scope
  // (`app.routes.ts` builds its routes from the feature flags).
  const [{ appConfig }, { AppComponent }] = await Promise.all([
    import('./app/app.config'),
    import('./app/app.component'),
  ]);

  await bootstrapApplication(AppComponent, appConfig);
}
// eslint-disable-next-line no-console -- bootstrap failure has no app left to report it through
main().catch(err => console.error(err));
